module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-page"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Contact")]), _vm._v(" "), _c('div', {
    staticClass: "contact-page__paragraph"
  }, [_c('p', [_vm._v("Tu as envie de nous envoyer un mot d'amour ou une lettre d'insultes ? Tu as envie d'une dédicace de Boris ou d'une mèche de cheveux de Bastien (ou l'inverse) ? Tu as envie de dire à Lucas Moulox combien tu l'aimes ?")]), _vm._v(" "), _c('p', [_vm._v("Envoie-nous un message et promis on te répondra !")])]), _vm._v(" "), _c('div', {
    staticClass: "contact-page__mail--container"
  }, [_c('a', {
    staticClass: "contact-page__mail",
    attrs: {
      "href": "mailto:contact@p2j.fr"
    }
  }, [_vm._v("contact@p2j.fr")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-752d9a98"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contact.vue
// module id = 87
// module chunks = 0